//src\components\portal\portal_components\data_manager\data_controls.js
import React, { useState } from 'react';
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';

const DataControls = ({ 
  searchTerm, 
  setSearchTerm, 
  typeFilter, 
  setTypeFilter, 
  onAddUrl,
  setError 
}) => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [newUrl, setNewUrl] = useState('');
  const [newUrlType, setNewUrlType] = useState('site');

  const handleAddUrl = () => {
    if (!newUrl.trim()) return;

    // Validate URL format
    try {
      new URL(newUrl);
    } catch {
      setError('Please enter a valid URL');
      return;
    }

    const operation = {
      operation: 'add',
      type: newUrlType,
      url: newUrl.trim(),
      timestamp: new Date().toISOString()
    };

    onAddUrl(operation);
    
    // Close dialog and reset form
    setAddDialogOpen(false);
    setNewUrl('');
    setNewUrlType('site');
  };

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Search pages..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon sx={{ mr: 1, color: '#666' }} />
            }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <InputLabel>Filter by Type</InputLabel>
            <Select
              value={typeFilter}
              label="Filter by Type"
              onChange={(e) => setTypeFilter(e.target.value)}
            >
              <MenuItem value="all">All Types</MenuItem>
              <MenuItem value="site">Site Pages</MenuItem>
              <MenuItem value="doc">Documents</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setAddDialogOpen(true)}
            sx={{ 
              height: '56px',
              backgroundColor: '#00796b',
              '&:hover': { backgroundColor: '#00796b' }
            }}
          >
            Add URL
          </Button>
        </Grid>
      </Grid>

      {/* Add URL Dialog */}
      <Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add New URL</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="URL"
            value={newUrl}
            onChange={(e) => setNewUrl(e.target.value)}
            placeholder="https://example.com/page"
            sx={{ mt: 2, mb: 2 }}
          />
          <FormControl fullWidth>
            <InputLabel>Type</InputLabel>
            <Select
              value={newUrlType}
              label="Type"
              onChange={(e) => setNewUrlType(e.target.value)}
            >
              <MenuItem value="site">Site Page</MenuItem>
              <MenuItem value="doc">Document</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleAddUrl} variant="contained">Add</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DataControls;